import api from './client';

export const getMyCompany = () => api.get('/companies/me').then(r => r.data);
export const updateMyCompany = (data) => api.put('/companies/me', data).then(r => r.data);
export const getCompanyUsage = () => api.get('/companies/me/usage').then(r => r.data);
export const uploadCompanyLogo = (formData) => api.post('/companies/me/logo', formData, { headers: { 'Content-Type': 'multipart/form-data' } }).then(r => r.data);
export const getPlans = () => api.get('/plans').then(r => r.data);
